import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setToast } from "./redux/slice/system";

import { useLocalStorageToRedux } from "./components/hooks";
import { system_toast } from "./service/system";

import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";

export default function App() {
  const system = useSelector((state) => state.system);
  const dispatch = useDispatch();
  const toast = useRef(null);
  const localStorageToRedux = useLocalStorageToRedux();
  const [nowProgress, setNowProgress] = useState(0);

  // 控制 toast 顯示內容
  useEffect(() => {
    if (!system.toast) {
      return;
    }

    toast.current.show({
      ...system.toast,
    });

    // toast 顯示結束後，將全域 toast 資料清除
    setTimeout(() => {
      dispatch(setToast(null));
    }, system.toast.life ?? system_toast.life);
  }, [system.toast]);

  // 偵測是否有 localStorage，有則寫入 store
  useEffect(() => {
    localStorageToRedux();
  }, []);

  useEffect(() => {
    if (
      system.isProgress.show === false ||
      system.isProgress.percent === null ||
      system.isProgress.percent === undefined
    ) {
      setNowProgress(0);
      return;
    }

    let timer;
    for (let i = nowProgress; i <= system.isProgress.percent; i++) {
      timer = setTimeout(() => {
        setNowProgress(i);
      }, (i - nowProgress) * 50);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [system.isProgress]);

  return (
    <>
      {system.isProgress.show && (
        <>
          <div
            className="fixed flex align-items-center justify-content-center w-full h-full bg-black-alpha-20"
            style={{ zIndex: 1199 }}
          >
            <ProgressSpinner />
          </div>
          {system.isProgress.percent !== null && (
            <div
              className="fixed flex align-items-center justify-content-center w-full h-full"
              style={{ zIndex: 1199 }}
            >
              <div
                className="inline-flex align-items-center justify-content-center text-2xl border-circle"
                style={{
                  width: "76px",
                  height: "76px",
                  backgroundColor: "#ffffffad",
                }}
              >
                {`${nowProgress}%`}
              </div>
            </div>
          )}
        </>
      )}
      <Toast ref={toast} />
    </>
  );
}
